import { useQuery } from '@tanstack/react-query'

import { likedAudioIdsQuery } from '../helpers/likedAudioIdsQuery'

// Disabled for guests — they never like anything, so the query would only 401.
export const useLikedAudioIds = (enabled = true) =>
    useQuery({
        ...likedAudioIdsQuery(),
        enabled,
    })
